<script setup lang="ts">
const props = defineProps<{
    companyPub: any
    companyPri?: any
    isPrivate?: boolean
}>()

const { state } = useAppStore()
</script>

<template>
    <section class="section border-b border-chsc-raw">
        <UiContainer>
            <div class="flex items-start gap-9">
                <div class="flex flex-col items-center">
                    <div class="relative">
                        <img
                            :src="`/img/treshold-5.svg`"
                            alt="Treshold"
                            class="w-[104px]"
                        >
                        <span
                            class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 font-semibold text-base"
                            :style="{ color: '#D9D9D9' }"
                        >
                            0%
                        </span>
                    </div>
                </div>
                <p
                    class="w-8/12 mt-2 fs-4xl font-semibold font-montserrat"
                    :style="{
                        color: '#D9D9D9',
                    }"
                >
                    {{
                        state.tresholds[4].label
                    }}
                </p>
            </div>
        </UiContainer>
    </section>
</template>
